import React, { useRef } from 'react';
import type { CortesConfig } from '@/lib/layouts/types';
import { resolveCortesGeometry } from '@/lib/layouts/resolveCortesPreset';
import { LayoutAnchorEditor } from './LayoutAnchorEditor';

interface Props {
  config: CortesConfig;
  onConfigPatch: (patch: Partial<CortesConfig>) => void;
}

/** Drag the Cortes Manchete. Text Bar is vertical-only and full width. */
export const HeadlineBoxEditor: React.FC<Props> = ({ config, onConfigPatch }) => {
  const geometry = resolveCortesGeometry(config);
  const anchor = geometry.headline;
  // CortesFrame renders the saved box mode; preset names do not override it.
  const bar = config.headlineStyle?.boxMode === 'bar';
  const boxWidth = Math.min(100, Math.max(50, config.headlineBoxWidth ?? 88)) / 100;
  const geometryRef = useRef(geometry);
  geometryRef.current = geometry;
  const scaleRef = useRef(anchor.scale);
  scaleRef.current = anchor.scale;

  return (
    <LayoutAnchorEditor
      anchor={anchor}
      width={bar ? 1 : boxWidth}
      axis={bar ? 'y' : 'xy'}
      testId="cortes-headline-drag"
      onChange={({ x, y }) => onConfigPatch({
        geometry: { ...geometryRef.current, headline: { x, y, scale: scaleRef.current } },
      })}
    />
  );
};

export default HeadlineBoxEditor;
